/* eslint-disable no-throw-literal */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const useComponentDidMount = handler => {
    return useEffect(() => {
        return handler();
    }, []);
};

export const useComponentDidUpdate = (handler, deps) => {
    const isInitialMount = useRef(true);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;

            return;
        }

        return handler();
    }, deps);
};

export const useComponentWillUnmount = handler => {
    return useEffect(() => handler, []);
};

export function withRouter(Child) {
    return (props) => {
        const location = useLocation();
        const navigate = useNavigate();
        return <Child {...props} navigate={navigate} location={location} />;
    }
}

export function goToRoute(value) {
    return () => {
        const navigate = useNavigate();
        navigate(value);
    }
}

export const useScript = url => {
    useEffect(() => {
      const script = document.createElement('script');
  
      script.src = url;
      script.async = true;
  
      document.body.appendChild(script);
  
      return () => {
        document.body.removeChild(script);
      }
    }, [url]);
  };